/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

var _ = require('lodash');

module.exports = function(helpers, utils) {
    var returnResult = utils.returnResult;

    return {
        ternary: function(options, condition, value1, value2) {
            return returnResult(options, this, condition ? value1 : value2);
        },

        eq: function(options, a, b) {
            return returnResult(options, this, a === b);
        },

        is: function(options, value, op) {
            return returnResult(options, this, value === op);
        },

        gt: function(options, a, b) {
            return returnResult(options, this, a > b);
        },

        and: function(options, op1, op2) {
            return returnResult(
                options,
                this,
                op1 && (op2 || op2 === undefined),
            );
        },

        gte: function(options, value, op) {
            return returnResult(options, this, value >= op);
        },

        isnt: function(options, value, op) {
            return returnResult(options, this, value !== op);
        },

        lt: function(options, value, op) {
            return returnResult(options, this, value < op);
        },

        lte: function(options, value, op) {
            return returnResult(options, this, value <= op);
        },

        or: function(options) {
            return returnResult(options, this, _.find(options.args));
        },

        dbor: function(options, value1, op1, value2, op2) {
            return returnResult(
                options,
                this,
                value1 === op1 || value2 === op2,
            );
        },

        ifNth: function(options, nr, v) {
            return returnResult(options, this, v % nr === 0);
        },

        compare: function(options, left, operator, right) {
            var operators = {
                '==': function(l, r) {
                    // eslint-disable-next-line
                    return l === r; //NOSONAR
                },
                '===': function(l, r) {
                    return l === r;
                },
                '!=': function(l, r) {
                    // eslint-disable-next-line
                    return l !== r; //NOSONAR
                },
                '!==': function(l, r) {
                    return l !== r;
                },
                '<': function(l, r) {
                    return l < r;
                },
                '>': function(l, r) {
                    return l > r;
                },
                '<=': function(l, r) {
                    return l <= r;
                },
                '>=': function(l, r) {
                    return l >= r;
                },
                typeof: function(l, r) {
                    return typeof l === r;
                },
            };

            if (!operators[operator]) {
                return returnResult(options, this, false);
            }
            return returnResult(
                options,
                this,
                operators[operator](left, right),
            );
        },

        ifEven: function(options, conditional) {
            return returnResult(options, this, conditional % 2 === 0);
        },

        isDivisible: function(options, pos, order) {
            if (!pos || !order) {
                return returnResult(options, this, false);
            }
            return returnResult(options, this, pos % order === 0);
        },

        own: function(options, property) {
            return returnResult(
                options,
                this,
                (this.hasOwnProperty(property) && this[property]) || null,
            );
        },
    };
};
